
// import CryptoJS from "crypto-js";
// let Key= process.env.REACT_APP_ENC_KEY;



// const decryptUrlData = (data) => {
//     try {
//         var reb64 = CryptoJS.enc.Hex.parse(data);
//         var bytes = reb64.toString(CryptoJS.enc.Base64);
//         var decrypt = CryptoJS.AES.decrypt(bytes, Key);
//         var plain = decrypt.toString(CryptoJS.enc.Utf8);
//         return plain ? JSON.parse(plain) : false;
//     } catch (error) {
//         console.error("Decryption failed:", error);
//         return false;
//     }

// };

// export { encryptUrlData, decryptUrlData }

import CryptoJS from "crypto-js";

// Convert the key to Base64 format
let Key = process.env.REACT_APP_ENC_KEY;
let IV = CryptoJS.enc.Base64.parse('123456'); // 16-byte IV

const encryptUrlData = (data) => {
    let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), Key, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString(); // Shorter Base64 output
};

const decryptUrlData = (encryptedText) => {
    try {
        let decrypted = CryptoJS.AES.decrypt(encryptedText, Key, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        let plainText = decrypted.toString(CryptoJS.enc.Utf8);
        return plainText ? JSON.parse(plainText) : false;
    } catch (error) {
        return false;
    }
};
const encryptUrlDatapattern = (data) => {
    var b64 = CryptoJS.AES.encrypt(JSON.stringify(data), Key).toString();
    var e64 = CryptoJS.enc.Base64.parse(b64);
    var eHex = e64.toString(CryptoJS.enc.Hex);
    return eHex;
};
const decryptUrlDatapattern = (data) => {
    try {
        var reb64 = CryptoJS.enc.Hex.parse(data);
        var bytes = reb64.toString(CryptoJS.enc.Base64);
        var decrypt = CryptoJS.AES.decrypt(bytes, Key);
        var plain = decrypt.toString(CryptoJS.enc.Utf8);
        return plain ? JSON.parse(plain) : false;
    } catch (error) {
        console.error("Decryption failed:", error);
        return false;
    }

};

export { encryptUrlData, decryptUrlData, encryptUrlDatapattern, decryptUrlDatapattern };



